export default __webpack_public_path__ + "static/media/datascript.26cd57e2.jpg";